import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Breadcrumb from '../components/Common/Breadcrumb';
import axios from 'axios';
import createSignedRequest from '../store/actions/createSignedRequest';
import { WaveformLoader, NoPermissions } from '../components/Common/ReusableComponents/Reusable';
import { Button } from '../components/ui/button';
import { Alert } from '../components/ui/alert';
import { Card } from '../components/ui/card';
import { BookOpen, X, Loader2, Eye, Copy, CircleHelp } from 'lucide-react';
const { apiURL } = require('../store/actions/apiURL');

const Developer = ({ currentOrganisation, hasAccess }) => {
  const [hasClientID, setHasClientID] = React.useState(false);
  const [clientId, setClientId] = React.useState(''); // Add your Client ID here
  const [clientSecret, setClientSecret] = React.useState(''); // Add your Client Secret here
  const [showLoader, setShowLoader] = React.useState(false);
  const [pageLoader, setPageLoader] = React.useState(true);
  const [alertMessage, setAlertMessage] = React.useState({});
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (currentOrganisation) {
      setOpen(false);
      setPageLoader(true);
      setAlertMessage({});
      setClientId('');
      setClientSecret('');
      const getClientIdByOrgId = async (orgId) => {
        try {
          const response = await axios(
            await createSignedRequest('GET', apiURL + `/my/developer/getClientIdByOrgId`, null, {
              Organisation: String(orgId),
            }),
          );
          console.log('response:', response);
          const data = response.data;
          if (data !== null) {
            setClientId(data);
            setHasClientID(true);
          } else {
            setHasClientID(false);
          }
        } catch (error) {
          // Handle any errors that occur during the fetch request
          console.error('Error:', error);
        }
        setPageLoader(false);
      };

      getClientIdByOrgId(currentOrganisation);
    }
  }, [currentOrganisation]);

  const rows = [
    {
      name: 'Client ID',
      description:
        "Click on 'Generate Client ID' in order to generate your client Id to be used with OAuth 2.0 authentication.",
      field: clientId,
    },
    {
      name: 'Client Secret',
      description: 'This is the client secret needed in order to authenticate with the OAuth 2.0 provider.',
      field: clientSecret === '' ? '******************' : clientSecret,
    },
    {
      name: 'Auth URL',
      description: '',
      field: apiURL.includes('archerirm')
        ? 'https://cyf-archer.auth.eu-west-2.amazoncognito.com/oauth2/authorize'
        : 'https://auth.compareyourfootprint.com/oauth2/authorize', // Add your Auth URL here
    },
    {
      name: 'Access Token URL',
      description: '',
      field: apiURL.includes('archerirm')
        ? 'https://cyf-archer.auth.eu-west-2.amazoncognito.com/oauth2/token'
        : 'https://auth.compareyourfootprint.com/oauth2/token', // Add your Access Token URL here
    },
  ];

  const generateClientId = async () => {
    setShowLoader(true);
    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + `/my/developer/createApp`, null, {
          Organisation: String(currentOrganisation),
        }),
      );
      const data = response.data;
      // Handle the data or the response here
      if (data?.clientId) {
        setOpen(true);
        setAlertMessage({ message: data?.message, severity: 'success' });
        setClientId(data?.clientId);
        setHasClientID(true);
      } else {
        setHasClientID(false);
      }
    } catch (error) {
      // Handle any errors that occur during the fetch request
      console.error('Error:', error);
      setAlertMessage({ message: error.message, severity: 'error' });
      setOpen(true);
    }
    setShowLoader(false);
  };

  const getClientSecret = async () => {
    setShowLoader(true);
    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + `/my/developer/getClientSecret?clientId=${clientId}`, null, {
          Organisation: String(currentOrganisation),
        }),
      );
      console.log('response:', response);
      const data = response.data;
      if (data?.error) {
        setAlertMessage({ message: data?.message, severity: 'error' });
        setOpen(true);
      } else {
        setClientSecret(data);
      }
    } catch (error) {
      // Handle any errors that occur during the fetch request
      console.error('Error:', error);
    }
    setShowLoader(false);
  };

  const getDocsUrl = () => {
    const currUrl = window.location.href;
    if (currUrl.split('.')[0].includes('dev' || 'localhost')) {
      return 'https://api.app.compareyourfootprint.com/dev/api-docs/';
    } else if (currUrl.split('.')[0].includes('staging2')) {
      return 'https://api.app.compareyourfootprint.com/stage2/api-docs/';
    } else if (currUrl.split('.')[0].includes('staging')) {
      return 'https://api.app.compareyourfootprint.com/stage/api-docs/';
    } else if (currUrl.split('.')[0].includes('archerirm')) {
      return 'https://api.archerirm.compareyourfootprint.com/v1/api-docs/';
    } else {
      return 'https://api.app.compareyourfootprint.com/v1/api-docs/';
    }
  };

  if (!hasAccess) {
    return <NoPermissions />;
  }

  return (
    <React.Fragment>
      <Breadcrumb items={[{ label: 'Developer Dashboard', link: '/developer' }]} />
      <div className='col-lg-12'>
        <div style={{ display: 'flex', marginBottom: '20px', justifyContent: 'space-between' }}>
          <Button
            size="lg"
            variant="secondary"
            className="flex flex-row items-center w-[18%] min-w-[205px] h-20 text-[15px] justify-start text-black px-5 bg-white normal-case"
            onClick={() => {
              const url = getDocsUrl();
              window.open(url, '_blank');
            }}>
            <BookOpen size={16} strokeWidth={1.5} className="mr-2" />
            API Documentation
          </Button>
          <div className="flex flex-col justify-end">
            {open && (
              <Alert
                className={
                  'flex items-center gap-2 rounded-lg text-xs ' +
                  (alertMessage.severity === 'error'
                    ? 'border-destructive/50 bg-destructive/10 text-destructive'
                    : 'border-primary/50 bg-primary/10 text-primary')
                }>
                <span className="flex-1">{alertMessage.message}</span>
                <button
                  type="button"
                  aria-label="close"
                  className="shrink-0 rounded p-1 opacity-70 hover:opacity-100"
                  onClick={() => setOpen(false)}>
                  <X size={16} strokeWidth={1.5} />
                </button>
              </Alert>
            )}
          </div>
        </div>
        {pageLoader ? (
          <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
            <WaveformLoader />
          </div>
        ) : (
          <section className='panel'>
            <header className='panel-heading' style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <b>API Information</b>
              </div>
              <Button
                onClick={() => {
                  generateClientId();
                }}
                disabled={showLoader}
                style={{
                  display: hasClientID ? 'none' : 'flex',
                  marginRight: 10,
                  alignContent: 'center',
                }}>
                Generate Client ID
                {'  '}
                <Loader2
                  size={16}
                  strokeWidth={1.5}
                  className='animate-spin'
                  style={{
                    display: showLoader ? 'flex' : 'none',
                    marginLeft: '10px',
                    marginTop: '2px',
                    justifyContent: 'center',
                  }}
                />
              </Button>
            </header>
            <div className='panel-body'>
              <Card className="mb-3 p-5 rounded-none shadow-none overflow-x-auto">
                <table
                  id='api-settings'
                  className='app-table'
                  style={{ borderCollapse: 'collapse', justifyContent: 'center' }}>
                  <tbody>
                    {rows.map((row, i) => (
                      <React.Fragment key={i}>
                        <tr border='2px'>
                          <td width='20%' height='70px' style={{ paddingRight: '20px' }}>
                            {rows[i].name}
                          </td>
                          <td width='55%' style={{ paddingRight: '20px' }}>
                            {rows[i].description}
                          </td>
                          <td width='25%'>
                            {rows[i].field === '' ? (
                              <>{rows[i].field}</>
                            ) : i === 1 ? (
                              <div style={{ display: clientId === '' ? 'none' : 'flex' }}>
                                <code style={{ color: 'black', backgroundColor: 'inherit' }}>{rows[i].field}</code>
                                {'   '}
                                {/* Show secret button visible only when ClientId is set and Client Secret has not been fetched yet */}
                                <Button
                                  type="button"
                                  variant="ghost"
                                  size="icon"
                                  className={
                                    'relative ' + (clientSecret !== '' || showLoader === true ? 'hidden' : 'flex')
                                  }
                                  onClick={() => getClientSecret()}>
                                  <Eye size={16} strokeWidth={1.5} />
                                </Button>
                                {/* Spinner icon shown only when show secret button is pressed until function finishes */}
                                <div
                                  style={{
                                    display: showLoader ? 'flex' : 'none',
                                    width: '20px',
                                    height: '20px',
                                    paddingLeft: 15,
                                  }}>
                                  <Loader2 size={16} strokeWidth={1.5} className='animate-spin' />
                                </div>
                                {'   '}
                                {/* Copy button shown only when Client secret has been fetched */}
                                <Button
                                  type="button"
                                  variant="ghost"
                                  size="icon"
                                  className={'relative ' + (clientSecret === '' ? 'hidden' : 'flex')}
                                  onClick={() => navigator.clipboard.writeText(rows[i].field)}>
                                  <Copy size={16} strokeWidth={1.5} />
                                </Button>
                              </div>
                            ) : (
                              <>
                                <code style={{ color: 'black', backgroundColor: 'inherit' }}>{rows[i].field}</code>
                                {'   '}
                                <Button
                                  type="button"
                                  variant="ghost"
                                  size="icon"
                                  className="relative"
                                  onClick={() => navigator.clipboard.writeText(rows[i].field)}>
                                  <Copy size={16} strokeWidth={1.5} />
                                </Button>
                              </>
                            )}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </Card>
            </div>
          </section>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const features = state?.features;
  const availableFeatures = state.organisation?.details?.features;
  const apiFeature = features?.find((feature) => feature.featureKey === 'API_ACCESS');
  const hasAccess = availableFeatures?.includes('API_ACCESS') || apiFeature?.enabledByDefault;
  return {
    currentOrganisation: state.currentOrganisation,
    hasAccess: hasAccess || false,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Developer);
